import script from "./AdminDashboardClientAdminViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardClientAdminViewer.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardClientAdminViewer.vue?vue&type=style&index=0&id=5cfa8fbc&lang=css"
import "./AdminDashboardClientAdminViewer.vue?vue&type=style&index=1&id=5cfa8fbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfa8fbc"]])

export default __exports__